<template>
  <span v-if="!task.discarded">
    <i class="material-icons pointer" data-toggle="modal" :data-target="'#moveModal' + task.id">arrow_forward</i>
    <div class="modal fade" :id="'moveModal' + task.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Where would you like to move this item to?</h5>
          </div>
          <div class="modal-body">
            <div class="mb-2">
              <em>
                {{task.title}}
              </em>
            </div>

            <select v-model="moveToSelected" name="project_area_id" class="form-control">
              <option value="default" disabled selected>Click here to select a new project for this todo</option>
              <option value="">Inbox</option>
              <option v-for="project in starredProjects" :value="project.id">
                  {{project.name}}
              </option>
              <optgroup v-for="project_area in project_areas" :label="project_area.name">
                <option v-for="project in unstarredProjects(project_area.projects)" :value="project.id">
                  {{ project.name }}
                </option>
              </optgroup>
            </select>


          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="moveTask(task)">Move Todo</button>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import api from "api";

export default {
  props: {
    task: {
      type: Object
    }
  },
  computed: {
    project_areas: {
      get() {
          return this.$store.state.project_areas
      },
    },
    starredProjects: {
      get(){
        var starredArray = []

        this.$store.state.project_areas.forEach(function(project_area, index){
          project_area.projects.filter(function (project){
            if(project.starred){
              starredArray.push(project)
            }
          })
        })
        return starredArray;
      }
    }
  },
  data() {
    return {
      moveToSelected: 'default',
    };
  },
  methods: {
    moveTask(task) {
      var router = this.$router
      api.updateTask(task.id, { project_id: this.moveToSelected }).then(response => {
        $('#moveModal' + this.task.id).modal('hide');
        $('body').removeClass('modal-open');
        $(".modal-backdrop").hide();
      });
    },
    unstarredProjects(projectsArray){
      return projectsArray.filter(project => project.starred === false)
    }
  }
}
</script>
